import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import text from 'styles/utility/text.module.scss'
import { Description } from 'components/Typography'
import { NavButton } from 'components/Button'

const DeliveryScheduleEditCompleteTemplate: FC = () => {
  return (
    <div className={styles.standard}>
      <Spacer size={48} />
      <FlexColumn alignItems={'center'}>
        <img src={'/icon/done/schedule.svg'} alt={'お届け可能日の設定が完了しました'} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>
          お届け可能日の設定が
          <br />
          完了しました
        </h2>
        <Spacer size={12} />
        <Description
          align={'center'}
          description={
            'sacriを立ち上げて、ご自身の店舗のページを確認しましょう。商品が注文された際は、メールにてお知らせいたします。'
          }
        />
      </FlexColumn>
      <Spacer size={48} />
      <NavButton label={'お届け可能日設定に戻る'} iconPath={'/icon/grey/arrow_prev.svg'} url={'/schedule/delivery'} />
      <Spacer size={12} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/order/delivery'} />
      <Spacer size={72} />
    </div>
  )
}

export default DeliveryScheduleEditCompleteTemplate
